// Next Diamonds — Delivery date mirror (PDP)
// Reads the "Get it by" date shown by pdp-delivery-estimator and injects it
// as a line item property on every cart-add form on the PDP. The property is
// named "_Get it by": the leading underscore keeps Shopify from printing it
// under the item in checkout/cart (checkout has its own delivery sticker),
// while the date still travels with the order into the merchant's order admin.
//
// Multiple safety nets in case timing is unfriendly:
//   1. Initial harvest + MutationObserver on the date element
//   2. Capture-phase form `submit` handler — re-reads at submission
//   3. Capture-phase `click` handler on Add-to-Cart buttons
//   4. `fetch` patch on /cart/add.js as a last-resort safety net
// We explicitly skip the "..." placeholder text that the snippet renders
// before pdp-delivery-estimator.js fills in a real date.

(function () {
  'use strict';

  function getDate() {
    var el = document.querySelector('[data-nd-delivery-date]');
    if (!el) return '';
    var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    // Skip placeholder. The widget renders "..." until the estimator JS
    // computes a real date string (e.g. "Mon, May 25").
    if (!text || text === '...' || text === '…' || text.length < 4) return '';
    return text;
  }

  function getProductForms() {
    return document.querySelectorAll(
      'form[action*="/cart/add"], product-form form, form[action$="/cart/add"]'
    );
  }

  function ensureProp(form, key, value) {
    if (!value) return;
    var existing = form.querySelector('input[name="properties[' + key + ']"]');
    if (existing) { existing.value = value; return; }
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[' + key + ']';
    input.value = value;
    form.appendChild(input);
  }

  function inject() {
    var date = getDate();
    if (!date) return;
    getProductForms().forEach(function (form) {
      ensureProp(form, '_Get it by', date);
    });
  }

  function startWatching() {
    var el = document.querySelector('[data-nd-delivery-date]');
    if (!el) {
      if (startWatching.tries == null) startWatching.tries = 0;
      if (startWatching.tries++ < 20) setTimeout(startWatching, 500);
      return;
    }
    if (typeof MutationObserver !== 'undefined') {
      var mo = new MutationObserver(inject);
      mo.observe(el, { childList: true, characterData: true, subtree: true });
    }
    inject();
  }

  // Safety net 1: form submit (covers classic form posts and most modern flows)
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    var date = getDate();
    if (date) ensureProp(form, '_Get it by', date);
  }, true);

  // Safety net 2: click on Add-to-Cart button (capture phase, runs before
  // Symmetry's AJAX collects the FormData)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[name="add"], button[type="submit"], product-form button, .product-form__cart-submit');
    if (!btn) return;
    var form = btn.closest('form[action*="/cart/add"], form[action$="/cart/add"]');
    if (!form) {
      var pf = btn.closest('product-form');
      if (pf) form = pf.querySelector('form');
    }
    if (!form) return;
    var date = getDate();
    if (date) ensureProp(form, '_Get it by', date);
  }, true);

  // Safety net 3: fetch patch on /cart/add.js — if the form-input mechanism
  // missed for any reason, this guarantees the property lands on the request
  if (window.fetch && !window.fetch.__ndDeliveryPatched) {
    var origFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      try {
        var url = '';
        if (typeof input === 'string') url = input;
        else if (input && input.url) url = input.url;
        var path = (url || '').split('?')[0].split('#')[0];
        if (/\/cart\/add(\.js)?$/.test(path) && init && init.body) {
          var date = getDate();
          if (date) {
            if (typeof FormData !== 'undefined' && init.body instanceof FormData) {
              if (!init.body.has('properties[_Get it by]')) {
                init.body.append('properties[_Get it by]', date);
              }
            }
          }
        }
      } catch (e) {}
      return origFetch(input, init);
    };
    window.fetch.__ndDeliveryPatched = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startWatching);
  } else {
    startWatching();
  }
  // Re-run later in case product forms mount asynchronously
  setTimeout(inject, 1500);
})();
